// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3WVXo","topBottomGutter":"Layout_topBottomGutter__1u6Kj"};